/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierUserCreateWhatsAppUserRequest
 */
export interface CourierUserCreateWhatsAppUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierUserCreateWhatsAppUserRequest
     */
    parameters?: string;
}

/**
 * Check if a given object implements the CourierUserCreateWhatsAppUserRequest interface.
 */
export function instanceOfCourierUserCreateWhatsAppUserRequest(value: object): value is CourierUserCreateWhatsAppUserRequest {
    return true;
}

export function CourierUserCreateWhatsAppUserRequestFromJSON(json: any): CourierUserCreateWhatsAppUserRequest {
    return CourierUserCreateWhatsAppUserRequestFromJSONTyped(json, false);
}

export function CourierUserCreateWhatsAppUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierUserCreateWhatsAppUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
    };
}

export function CourierUserCreateWhatsAppUserRequestToJSON(json: any): CourierUserCreateWhatsAppUserRequest {
    return CourierUserCreateWhatsAppUserRequestToJSONTyped(json, false);
}

export function CourierUserCreateWhatsAppUserRequestToJSONTyped(value?: CourierUserCreateWhatsAppUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parameters': value['parameters'],
    };
}

